/* eslint-disable camelcase */
import React, {
  ReactElement,
  forwardRef,
  useState,
  useEffect,
  useRef,
} from 'react';
import {
  Button,
  makeStyles,
  DialogContent,
  DialogActions,
  Dialog,
  Tooltip,
} from '@material-ui/core';
import MaterialTable, {Icons} from 'material-table';
import {Clear, Search, CheckCircle} from '@material-ui/icons';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import {useTranslation} from 'react-i18next';
import Pagination from '@material-ui/lab/Pagination';
// styles and styles object
import './CasesStyles.scss';
import {
  caseOpenStyles,
  caseReopenedStyles,
  caseClosedStyles,
  tableCellStyles,
  manageHeaderStyles,
  headerStyles,
  cellStylesObject,
} from './caseStyles';
// popover component
import CustomPopOver from './custompopover/CustomPopOver';

// service methods;
import {
  getAllCases,
  updateCaseDetails,
  resetCases,
} from '../../../../shared/src/services/CasesServices';
import {_snackbarAcknowledgement} from '../../../../shared/src/store/actions/AuthActions';

import {connect} from 'react-redux';
import DateTimeUtils from '../../../../shared/src/utils/DateTimeUtils';
import SearchField from '../../components/search/SearchField';
import AppLoader from '../../components/apploader/AppLoader';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiToolbar-regular': {
      minHeight: 0,
    },
  },
  button: {
    borderRadius: 8,
    width: '6.6rem',
    height: '2.84rem',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
  },
  saveButton: {
    borderRadius: 8,
    height: '2.84rem;',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
  },
  dialog: {
    '& .MuiDialog-paperScrollPaper': {
      borderRadius: 8,
      boxShadow: '0 10px 30px 0 rgba(0, 0, 0, 0.05)',
    },
  },
}));

const paginationStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const Cases = (props: any): ReactElement => {
  const classes = useStyles();
  const pageStyes = paginationStyles();
  const {t} = useTranslation();
  const [anchorEl, setAnchorEl]: any = useState(null);
  const [manageText, setManagetext] = useState<string>('');
  const [allCasesData, setAllCasesData]: any = useState([]);
  const [casePid, setCasePid]: any = useState('');
  const [offSet, setOffset] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const searchTextRef = useRef('');
  const [resetCase, setResetCase] = useState<{
    isOpen: boolean;
    case_id: number;
  }>({
    isOpen: false,
    case_id: 0,
  });
  const getCases = async (
    offValue: any,
    searchText?: string
  ): Promise<void> => {
    try {
      const search_text = searchText ? searchText : '';
      const cases = await getAllCases(offValue, search_text);
      if (cases && cases?.data && cases?.data?.allSurgeryCases) {
        setAllCasesData(cases.data.allSurgeryCases.rows);
        if (cases.data.allSurgeryCases.count) {
          setPageCount(Math.ceil(cases.data.allSurgeryCases.count / 8));
        }
      } else {
        setAllCasesData([]);
      }
    } catch (error) {
      const err = error as any;
      props._snackbarAcknowledgement(
        true,
        err?.message || t('COMMON.GETERROR'),
        t('COMMON.ERRORTEXT')
      );
      throw error;
    }
  };

  useEffect(() => {
    getCases(offSet);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const optionsObject: any = {
    search: false,
    paging: false,
    header: true,
    showTitle: false,
    sorting: true,
    headerStyle: {
      ...headerStyles,
    },
  };

  const tableIcons: Icons = {
    ResetSearch: forwardRef((prop, ref) => <Clear {...prop} ref={ref} />),
    Search: forwardRef((prop, ref) => <Search {...prop} ref={ref} />),
    SortArrow: forwardRef((prop, ref) => (
      <ArrowDropDownIcon {...prop} ref={ref} color="primary" fontSize="large" />
    )),
  };
  const handleCustomPopOver = (
    event: any,
    text: any,
    caseId: any,
    index: any
  ): void => {
    setCasePid(caseId);
    setManagetext(text);
    setAnchorEl(event.target);
  };

  const openResetModel = (case_pid: number) => {
    setResetCase({
      isOpen: true,
      case_id: case_pid,
    });
  };

  const closeResetModel = () => {
    setResetCase({...resetCase, isOpen: false, case_id: 0});
  };

  const handleReset = async () => {
    setIsLoading(true);
    try {
      const response = await resetCases(resetCase.case_id);
      if (response && response.status === 'Success') {
        props._snackbarAcknowledgement(
          true,
          response.message,
          t('COMMON.SUCCESS')
        );
        getCases(offSet);
      }
    } catch (error) {
      const err = error as any;
      props._snackbarAcknowledgement(
        true,
        err?.message || t('COMMON.GETERROR'),
        t('COMMON.ERRORTEXT')
      );
      throw error;
    } finally {
      setIsLoading(false);
    }
    closeResetModel();
  };

  const resetDialog = (): ReactElement => {
    return (
      <Dialog
        open={resetCase.isOpen}
        onClose={closeResetModel}
        maxWidth={'md'}
        className={classes.dialog}>
        <DialogContent>
          <div className="form-container">
            <div className="title-container">
              <div className="title-view">
                <span className="title-text">{t('CASES.RESETCASE')}</span>
              </div>
            </div>
            <div className="text-field-container">
              <p className="text-field-label">
                {t('CASES.RESETCASECONFIRMATIONTEXT')}
              </p>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="actions-container">
          <Button
            variant="contained"
            size="large"
            className={[classes.saveButton, 'cancle-button'].join(' ')}
            onClick={closeResetModel}>
            <span className="button-text">{t('CASES.CANCELRESET')}</span>
          </Button>
          <Button
            variant="contained"
            size="large"
            className={[classes.saveButton, 'yes-button'].join(' ')}
            onClick={() => handleReset()}>
            <span className="button-text">{t('CASES.CONFIRMRESET')}</span>
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const columnsList: any = [
    {
      title: t('CASES.CLINICIAN'),
      field: 'clinician_name',
      cellStyle: {
        ...tableCellStyles,
      },
    },
    {
      title: t('CASES.PATIENT_NAME'),
      field: 'patient_name',
      cellStyle: {
        ...tableCellStyles,
      },
    },
    {
      title: t('CASES.CASE_NUMBER'),
      field: 'case_pid',
      cellStyle: {
        ...tableCellStyles,
      },
    },
    {
      title: t('CASES.PATIENT_FORMS'),
      field: 'patient_forms_signed',
      cellStyle: {
        ...tableCellStyles
      },
      render: (rowData: any) => (
        rowData.patient_forms_signed ? (
          <Tooltip title={t('CASES.PATIENT_FORMS')}>
            <CheckCircle style={{ color: '#4CAF50' }} />
          </Tooltip>
        ) : '-'
      )
    },
    {
      title: t('CASES.DOCUMENTS'),
      field: 'documents_count',
      cellStyle: {
        ...tableCellStyles,
      },
    },
    {
      title: t('CASES.LAST_STATUS_CHANGE'),
      field: 'modified_at',
      render: (rowData: any) => (
        <div>{DateTimeUtils.formatDateMDY(rowData.modified_at)}</div>
      ),
      cellStyle: {
        ...tableCellStyles,
      },
    },
    {
      title: t('CASES.MANAGE'),
      field: 'manage',
      render: (rowData: any, index: any) => (
        <div>
          {rowData.re_opened ? (
            <div
              // @ts-ignore
              style={{...caseReopenedStyles}}>
              {t('CASES.RE_OPENED')}
            </div>
          ) : rowData.closed ? (
            <div
              onClick={(event: any) =>
                handleCustomPopOver(
                  event,
                  'ReOpen Case',
                  rowData.case_pid,
                  index
                )
              }
              id={'simple-popover'}
              // @ts-ignore
              style={{...caseClosedStyles}}>
              {t('CASES.CLOSED')}
            </div>
          ) : (
            <div
              // @ts-ignore
              style={{...caseOpenStyles}}>
              {t('CASES.OPEN')}
            </div>
          )}
        </div>
      ),
      cellStyle: {
        ...tableCellStyles,
        width: '11%',
      },
      headerStyle: {
        ...manageHeaderStyles,
      },
    },
    {
      title: '',
      field: 'reset_case',
      render: (rowData: any) => {
        return (
          <div>
            {rowData.closed && !rowData.re_opened ? (
              <Tooltip title="Cannot reset a closed case">
                <Button className="disabled-reset-case-button">
                  {t('CASES.RESETCASE')}
                </Button>
              </Tooltip>
            ) : (
              <Button
                onClick={() => openResetModel(rowData.case_pid)}
                className="reset-case-button">
                {t('CASES.RESETCASE')}
              </Button>
            )}
          </div>
        );
      },
      cellStyle: {
        ...tableCellStyles,
        width: '11%',
        textAlign: 'center',
      },
    },
  ];

  const handleClose = (): void => {
    setManagetext('');
    setAnchorEl(null);
  };

  const updateCaseStatus = async (): Promise<void> => {
    // eslint-disable-next-line no-useless-catch
    try {
      const updateObject = {
        closed: false,
        in_progress: true,
        re_opened: true,
        modified_at: new Date(),
      };
      const updateResponse = await updateCaseDetails(casePid, updateObject);
      if (updateResponse && updateResponse?.data) {
        getCases(offSet);
        props._snackbarAcknowledgement(
          true,
          t('CASES.STATUS_SUCCESS'),
          t('COMMON.SUCCESS')
        );
      }
    } catch (error) {
      const err = error as any;
      props._snackbarAcknowledgement(
        true,
        (err && err.message) || t('CASES.STATUS_ERROR'),
        t('COMMON.DANGER')
      );
      throw err;
    } finally {
      setAnchorEl(null);
    }
  };

  const handleSearchText = (event: any): void => {
    const searchText = event.target.value;
    searchTextRef.current = searchText;
    getCases(offSet, searchText);
  };
  const handlePagination = (event: any, page: any) => {
    const searchText = searchTextRef.current;
    setOffset(page - 1);
    getCases(page - 1, searchText);
  };

  return isLoading ? (
    <AppLoader />
  ) : (
    <div className="cases-wrapper">
      <div className="cases-container">
        <div className="cases-view">
          <div className="cases-text">{t('CASES.TITLE')}</div>
          <div className="search-main-view">
            <div className="search-width">
              <SearchField
                placeholder={t('CASES.PLACEHOLDER')}
                onChange={(event: any): void => handleSearchText(event)}
              />
            </div>
          </div>
        </div>
        <div className={classes.root}>
          <MaterialTable
            icons={tableIcons}
            style={{...cellStylesObject}}
            columns={columnsList}
            data={allCasesData}
            options={optionsObject}
          />
        </div>
        {anchorEl && (
          <CustomPopOver
            anchorEl={anchorEl}
            handleClose={handleClose}
            manageText={manageText}
            updateCaseStatus={updateCaseStatus}
          />
        )}
        <div className="pagination-view">
          <div className={pageStyes.root}>
            <Pagination
              count={pageCount}
              shape="rounded"
              onChange={(event: any, page: any) =>
                handlePagination(event, page)
              }
            />
          </div>
        </div>
      </div>
      {resetDialog()}
    </div>
  );
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {_snackbarAcknowledgement})(Cases);